import { useEffect, useState } from 'react';

import {
  GlobalNavigation_ProcessesSuccessFragment,
  ProcessState,
} from 'Src/generated/graphql';

import { getEstimatedTimeForSteppedProcess } from './lib/getEstimatedTimeForSteppedProcess';

export enum EstimationHeuristic {
  AllStepsEqual,
  LastStepIsLongest,
}

export function useEstimatedTimeForSteppedProcess(
  process: Pick<
    GlobalNavigation_ProcessesSuccessFragment['nodes'][number],
    'createdAt' | 'stages' | 'state'
  > | null,
  options: {
    estimationHeuristic?: EstimationHeuristic;
    maxExpectedMinutesPerStep?: number;
    minExpectedMinutesPerStep?: number;
  } = {},
) {
  const [elapsedTime, setEstimatedTime] = useState(() =>
    getEstimatedTimeForSteppedProcess(process),
  );

  useEffect(() => {
    let timeout: number | null = null;

    setEstimatedTime(getEstimatedTimeForSteppedProcess(process, options));

    function updateEstimatedTime() {
      timeout = window.setTimeout(() => {
        setEstimatedTime(getEstimatedTimeForSteppedProcess(process, options));
        updateEstimatedTime();
      }, getRandomUpdateTime());
    }
    function cleanup() {
      if (timeout === null) return;
      window.clearTimeout(timeout);
    }

    if (process?.stages && process?.state === ProcessState.Processing) {
      updateEstimatedTime();
    }

    return cleanup;
  }, [process?.stages.map((stage) => stage.status).join()]);

  return elapsedTime;
}

function getRandomUpdateTime() {
  const min = 10000;
  const max = 30000;
  return Math.floor(Math.random() * (max - min) + min);
}
